const individualChartObject =  {
    exportFileName: "Doughnut Chart",
    zoomEnabled: false,
    title: {
      text: "",
    },
    toolTip: {
      shared: false,
      contentFormatter: function (e) {
        var content;
        content = e.entries[0].dataPoint.name + "<br/>";
        return content;
      },
    },
    legend: {
      fontSize: 19,
      verticalAlign: "center",
      horizontalAlign: "right",
    },
    data: [
      {
        type: "doughnut",
        showInLegend: false,
        explodeOnClick: false,
        startAngle: 270,
        radius: "90%",
        dataPoints: []
      },
    ],
  }

  module.exports = individualChartObject;